<template>
    <div class="wrap" :style="{position:(eShow1||eShow2||engDig)?'absolute':'',top:0,bottom:0,overflow:(eShow1||eShow2||engDig)?'hidden':'auto'}">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist' :style="{position:(eShow1||eShow2||engDig)?'absolute':'',top:0,bottom:0,overflow:(eShow1||eShow2||engDig)?'hidden':'auto'}">
                    <div class="blk1">
                        <img src="@/views/property/image/banner1@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                        <div class="blkps">
                            <div class="blkrect"></div>
                            <div class="txtku1">申报工单</div>
                        </div>
                    </div>
                    <div :class="{ 'mainSty': true,'fHeight':fhShow}">
                        <div class="alSty">
                            <div class="blkb">
                                <div class="txtc"></div>
                                <div>
                                    <div class="txtd">故障类型</div>
                                </div>
                                <div class="blkc" @click="ftSelect">

                                    <div class="txte" :style="'color:'+(fType=='请选择'?'red':'')">{{fType}}</div>
                                    <div class="blkf"><img src="@/views/index/image/back@2x.png" class="imga"></img></div>
                                </div>
                            </div>
                        </div>
                        <div class="alSty">
                            <div class="blkg">
                                <div class="txtc"></div>
                                <div>
                                    <div class="txtd">事件级别</div>
                                </div>
                                <div class="blkc" @click="etSelect">
                                    <div class="txte" :style="'color:'+(eType=='请选择'?'red':'')">{{eType}}</div>
                                    <div class="blkf" @click="etSelect"><img src="@/views/index/image/back@2x.png" class="imga"></img></div>
                                </div>
                            </div>
                        </div>
                        <div class="alSty">
                            <div class="blkg">
                                <div class="txtc"></div>
                                <div>
                                    <div class="txtd">最迟解决时间</div>
                                </div>
                                <div class="blkc" @click="cTSelect">
                                    <div class="txte" :style="'color:'+(TType=='请选择'?'red':'')">{{TType}}</div>
                                    <div class="blkf"><img src="@/views/index/image/back@2x.png" class="imga"></img></div>
                                </div>
                            </div>
                        </div>
                        <div class="alSty1">
                            <div class="blkg1">
                                <div class="txtc"></div>
                                <div>
                                    <div class="txtd">故障描述</div>
                                </div>
                                <div class="blkh1">
                                    <div class="txth">
                                        <div style="display:flex;flex-direction:row;flex-wrap:wrap">
                                            <div @click="cliSty(index,item)" class="mtSty" style="" v-for="(item,index) in estItem" :key="index">
                                                <div :class="{active:index==current,e_rect:true,hBorder:hType}">{{item.dictValue}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blkop">
                                    <van-field v-model="message" rows="7" autosize autofocus type="textarea" maxlength="255" placeholder="说明" show-word-limit class="inpup" :style="'border-color:'+(message==''?'#707070':'')" />
                                </div>
                            </div>
                        </div>
                        <!-- <div class="eng2txt">紧急情况下请直接拨打运维人员的电话</div> -->
                    </div>
                    <div>
                        <div v-if="yjShow">
                            <div class="mainSty2" v-if="itemList.tOpen==1">
                                <div class="blkn3">
                                    <div class="txt1">{{itemList.hardwareName}}</div>
                                </div>
                                <div class="blkn3">
                                    <div class="txt2">{{itemList.hardwareCode}}</div>
                                </div>
                                <div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产类型</div>
                                            <div class="txt12">{{itemList.hardwareType}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产品牌</div>
                                            <div class="txt12">{{itemList.hardwareBrand}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产型号</div>
                                            <div class="txt12">{{itemList.serial}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">保修状态</div>
                                            <div class="txt12">{{itemList.maintainStatus}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产状态</div>
                                            <div class="txt12">{{itemList.hardwareStatus}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产3d位置</div>
                                            <div class="txt12">{{itemList.assets3dAddress}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">网络位置</div>
                                            <div class="txt12">{{itemList.networkAddress}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">责任人</div>
                                            <div class="txt12">{{itemList.dutyPerson}}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;align-items:center;">
                                        <div class="btn16" @click="toOpen(itemList)">
                                            <van-icon name="arrow-down" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mainSty1" v-if="itemList.tOpen==2">
                                <div class="blkn3">
                                    <div class="txt1">{{itemList.hardwareName}}</div>
                                </div>
                                <div class="blkn3">
                                    <div class="txt2">{{itemList.hardwareCode}}</div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产类型</div>
                                        <div class="txt12">{{itemList.hardwareType}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产品牌</div>
                                        <div class="txt12">{{itemList.hardwareBrand}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产型号</div>
                                        <div class="txt12">{{itemList.version}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产序列号</div>
                                        <div class="txt12">{{itemList.serial}}</div>
                                    </div>
                                </div>

                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产价值（元）</div>
                                        <div class="txt12">{{itemList.value}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">生产厂家</div>
                                        <div class="txt12">{{itemList.manufacturer}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">购入日期</div>
                                        <div class="txt12">{{itemList.buyDate}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修状态</div>
                                        <div class="txt12">{{itemList.maintainStatus}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修开始日期</div>
                                        <div class="txt12">{{itemList.maintainStart}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修结束日期</div>
                                        <div class="txt12">{{itemList.maintainFinish}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产状态</div>
                                        <div class="txt12">{{itemList.hardwareStatus}}</div>
                                    </div>
                                </div>

                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产3d位置</div>
                                        <div class="txt12">{{itemList.assets3dAddress}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">网络位置</div>
                                        <div class="txt12">{{itemList.networkAddress}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">责任人</div>
                                        <div class="txt12">{{itemList.dutyPerson}}</div>
                                    </div>
                                </div>
                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;align-items:center;">
                                        <div class="btn16" @click="toClose(itemList)">
                                            <van-icon name="arrow-up" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="mainSty3" v-if="item.tOpen==1">
                                <div class="blkn3">
                                    <div class="txt1">{{item.softwareName}}</div>
                                </div>
                                <div class="blkn3">
                                    <div class="txt2">{{item.softwareCode}}</div>
                                </div>
                                <div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产类型</div>
                                            <div class="txt12">{{item.softwareType}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产品牌</div>
                                            <div class="txt12">{{item.softwareBrand}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产型号</div>
                                            <div class="txt12">{{item.version}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">保修状态</div>
                                            <div class="txt12">{{item.maintainStatus}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">资产状态</div>
                                            <div class="txt12">{{item.softwareStatus}}</div>
                                        </div>
                                    </div>
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">安装人</div>
                                            <div class="txt12">{{item.softwareInstallBy}}</div>
                                        </div>
                                    </div>
                                    <!-- <div class="blkt">
										    <div style="display:flex">
										        <div class="txt11">网络位置</div>
										        <div class="txt12">{{item.deployNetwork}}</div>
										    </div>
										</div> -->
                                    <div class="blkt">
                                        <div style="display:flex">
                                            <div class="txt11">责任人</div>
                                            <div class="txt12">{{item.dutyPerson}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;align-items:center;">
                                        <div class="btn16" @click="toOpen(item)">
                                            <van-icon name="arrow-down" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mainSty4" v-if="item.tOpen==2">
                                <div class="blkn3">
                                    <div class="txt1">{{item.softwareName}}</div>
                                </div>
                                <div class="blkn3">
                                    <div class="txt2">{{item.softwareCode}}</div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产类型</div>
                                        <div class="txt12">{{item.softwareType}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产品牌</div>
                                        <div class="txt12">{{item.softwareBrand}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产版本号</div>
                                        <div class="txt12">{{item.version}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">资产序列号</div>
                                        <div class="txt12">{{item.serial}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">活动日期</div>
                                        <div class="txt12">{{item.getDate}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">集成单位</div>
                                        <div class="txt12">{{item.dutyCompany}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">集成单位联系人</div>
                                        <div class="txt12">{{item.dutyPerson}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">集成单位联系方式</div>
                                        <div class="txt12">{{item.dutyPhone}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修状态</div>
                                        <div class="txt12">{{item.maintainStatus}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修开始日期</div>
                                        <div class="txt12">{{item.maintainStart}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">保修结束日期</div>
                                        <div class="txt12">{{item.maintainFinish}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">部署网络</div>
                                        <div class="txt12">{{item.deployNetwork}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">访问地址</div>
                                        <div class="txt12">{{item.visitLocation}}</div>
                                    </div>
                                </div>

                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">平台用户名</div>
                                        <div class="txt12">{{item.platformUser}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">平台密码</div>
                                        <div class="txt12">{{item.platformPassword}}</div>
                                    </div>
                                </div>
                                <!-- <div class="blkt">
										    <div style="display:flex">
										        <div class="txt11">访问IP</div>
										        <div class="txt12">{{item.osIp}}</div>
										    </div>
										</div> -->
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">操作系统用户名</div>
                                        <div class="txt12">{{item.osUser}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">操作系统密码</div>
                                        <div class="txt12">{{item.osPassword}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">远程端口</div>
                                        <div class="txt12">{{item.port}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">操作系统</div>
                                        <div class="txt12">{{item.os}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">许可种类(单机、网络、场地)</div>
                                        <div class="txt12">{{item.permissionType}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">许可数量留存方式(介质)</div>
                                        <div class="txt12">{{item.saveState}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">数量</div>
                                        <div class="txt12">{{item.saveNumber}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">日期</div>
                                        <div class="txt12">{{item.installDate}}</div>
                                    </div>
                                </div>
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">安装人</div>
                                        <div class="txt12">{{item.softwareInstallBy}}</div>
                                    </div>
                                </div>
                                <!-- <div class="blkt">
										    <div style="display:flex">
										        <div class="txt11">网络位置</div>
										        <div class="txt12">{{item.deployNetwork}}</div>
										    </div>
										</div> -->
                                <div class="blkt">
                                    <div style="display:flex">
                                        <div class="txt11">责任人</div>
                                        <div class="txt12">{{item.dutyPerson}}</div>
                                    </div>
                                </div>
                                <div class="blk2">
                                    <div style="display:flex;justify-content:center;flex:1;align-items:center;">
                                        <div class="btn16" @click="toClose(item)">
                                            <van-icon name="arrow-up" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="blkn">
                        <div style="flex:1;">
                            <div class="btnn">
                                <button :disabled="disabled" @click="submitBill" class="btnn">提交工单</button>
                            </div>
                            <!-- <button class="btnn"    @click="submitBill">提交工单</button> -->
                        </div>
                    </div>
                </div>
            </div>

            <div style="width:100%;height:100%" v-if="eShow2">
                <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.99;background: #333333;">
                    <div class="dialogs2">
                        <div class="digtxt1">事件级别</div>
                        <div style="display:flex;">
                            <div class="imgblk" @click="close"><img src="./image/x@2x.png" class="imgtlk"></img></div>
                            <div class="imghj" style="flex:1;">
                                <div class="rectSty">
                                    <div :class="className"></div>
                                    <div :class="className1">
                                        <div class="tRect"></div>
                                    </div>
                                </div>
                            </div>
                            <div style="flex:1">
                                <div class="digtxt2" @click="selectd(index,item)" v-for="(item,index) in dItem" :key="index">
                                    <div :style="{borderColor:color1}" :class="{active2:(current2==index),nbtn:true,nbtn1:true}">{{item.value}}</div>
                                </div>
                            </div>
                        </div>
                        <div style="display:flex;align-items:center;justify-content:center;background-color:white">
                            <div class="submit" @click="submit2">提交</div>
                        </div>
                    </div>

                </div>
            </div>
            <div style="width:100%;height:100%;" v-if="eShow1">
                <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.99;background: #333333;">
                    <div class="dialogs">
                        <div class="imgblk" @click="close"><img src="./image/x@2x.png" class="imgtlk"></img></div>
                        <div class="digtxt" style="margin-bottom:0">故障类型</div>
                        <div class="ofSty">
                            <div class="digtxt" @click="selects(index,item)" v-for="(item,index) in failItem" :key="index">
                                <div :class="{active1:current1==index,nbtn:true}">{{item.dictValue}}</div>
                            </div>
                        </div>
                        <div style="display:flex;align-items:center;justify-content:center">
                            <div class="submit" @click="submit">提交</div>
                        </div>
                    </div>
                </div>
            </div>

            <van-popup v-model:show="showTime" position="bottom">
                <van-datetime-picker v-model="currentDate" type="datetime" title="选择最迟解决时间" :formatter="formatter" :min-date="minDate" :max-date="maxDate" :columns-order="['year','month', 'day', 'hour','minute']" @cancel="cacelSelTime" @confirm="sleDate" />
            </van-popup>
            <div style="width:100%;height:100%" v-if="engDig">
                <div ref="dig" class="mtblk" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.99;background: #333333;">
                    <div class="dialogs dialogs1">
                        <div class="imgblk" @click="closeDig"><img src="./image/x@2x.png" class="imgtlk"></img></div>
                        <div class="digtxt">提交成功！<br />等待工程师响应</div>
                        <div style="display:flex;align-items:center;justify-content:center">
                            <div class="submit" @click="closeDig">确定</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>

</template>
<script>
export default {
    components: {},
    data() {
        return {
            yjShow: true,
            itemList: {
                tOpen: 1
            },
            item: {
                tOpen: 1
            },
            // 选择最迟解决时间的参数
            currentDate: undefined,
            showTime: false,
            lastFinishTime: undefined,
            minDate: new Date(new Date().getTime() + 1 * 60 * 1000),
            maxDate: new Date(new Date().getTime() + 364 * 24 * 60 * 60 * 1000),
            index: -1,
            title: "",
            code: "",
            diag: false,
            message: '',
            tmsg: '',
            color1: '#efefef',
            current: null,
            current1: null,
            current2: null,
            eShow1: false,
            eShow2: false,
            bSty: true,
            fType: '',
            fIndex: '',
            val1: '',
            eType: "",
            eIndex: "",
            val2: '',
            hType: false,
            fhShow: true,
            engDig: false,
            disabled: false,
            failItem: [
            ],
            estItem: [
            ],
            dItem: [
                {
                    id: "0",
                    value: '低'
                },
                {
                    id: "1",
                    value: '中'
                },
                {
                    id: "2",
                    value: '高'
                },
                {
                    id: "3",
                    value: '紧急'
                }
            ]
        }
    },
    created() {
        if (this.$route.query.responseType == 1) {
            this.yjShow = true
            this.getData()
        } else if (this.$route.query.responseType == 2) {
            this.yjShow = false
            this.getData1()
        }

    },
    watch() {

    },
    computed: {
        className() {
            return `height${this.index + 1}`;
        },
        className1() {
            return `sRect${this.index + 1}`;
        }
    },
    methods: {
        toOpen(item) {
            item.tOpen = 2
            this.$forceUpdate();
        },
        toClose(item) {
            item.tOpen = 1
            this.$forceUpdate();
        },
        getData1() {
            let data = { assetId: this.$route.query.id }
            this.$api.get('/app/corporateassets/sqglGetSoftwareAssetsById', { params: data }).then(res => {
                if (res.data.code == "0000") {
                    let item = res.data.data
                    item.maintainStatus = (item.maintainStatus == '1') ? '在保' : '过保'
                    if (item.hardwareStatus == 1) {
                        item.hardwareStatus = '使用'
                    } else if (item.hardwareStatus == 2) {
                        item.hardwareStatus = '维修'
                    } else if (item.hardwareStatus == 3) {
                        item.hardwareStatus = '报废'
                    }
                    if (item.permissionType == 1) {
                        item.permissionType = '单机'
                    } else if (item.permissionType == 2) {
                        item.permissionType = '网络'
                    } else if (item.permissionType == 3) {
                        item.permissionType = '场地'
                    } else {
                        item.permissionType = ''
                    }
                    item.tOpen = 1
                    if (item.softwareStatus == 1) {
                        item.softwareStatus = '使用'
                    } else if (item.softwareStatus == 2) {
                        item.softwareStatus = '维护'
                    } else if (item.softwareStatus == 3) {
                        item.softwareStatus = '停用'
                    }
                    // if(item.networkAddress==1){
                    // 	item.networkAddress='内网'
                    // }else if(item.networkAddress==2){
                    // 	item.networkAddress='外网'
                    // }else{
                    // 	item.networkAddress=''
                    // }
                    this.item = item;
                    this.getlevelData(item.companyId)
                    this.getDescribeData(item.companyId)
                }
            }
            )
        },
        getData() {
            let data = { hardwareId: this.$route.query.id }
            this.$api.get('/app/corporateassets/getHardwareAssetsById', { params: data }).then(res => {
                if (res.data.code == "0000") {
                    let item = res.data.data;
                    item.tOpen = 1;
                    item.maintainStatus = (item.maintainStatus == '1') ? '在保' : '过保';
                    if (item.hardwareStatus == 1) {
                        item.hardwareStatus = '使用'
                    } else if (item.hardwareStatus == 2) {
                        item.hardwareStatus = '维修'
                    } else if (item.hardwareStatus == 3) {
                        item.hardwareStatus = '报废'
                    }
                    if (item.softwareList) {
                        item.softwareList.forEach(item1 => {
                            if (item1.softwareStatus == 1) {
                                item1.softwareStatus = '使用'
                            } else if (item1.softwareStatus == 2) {
                                item1.softwareStatus = '维护'
                            } else if (item1.softwareStatus == 3) {
                                item1.softwareStatus = '停用'
                            }
                        })
                    }
                    this.itemList = item;
                    this.getlevelData(item.companyId)
                    this.getDescribeData(item.companyId)
                }
            }
            )

        },
        cliSty(index, item) {
            this.current = index;
            this.tmsg = item.dictValue
            this.hType = false
            if (item.vId && item.vId == this.estItem.length - 1) {
                this.diag = true
                this.fhShow = false
            } else {
                this.diag = false
                this.fhShow = true
            }
        },
        selects(index, val) {
            this.current1 = index;
            this.val1 = val.dictValue
            this.fIndex = val.dictId
        },
        toIndex() {
            this.$router.push('/index')
        },
        submit2() {
            this.eShow2 = 0;
            this.eType = this.val2;
        },
        submit() {
            this.eShow1 = 0
            this.fType = this.val1;
        },
        selectd(index, val) {
            this.current2 = index;
            if (this.current2 == 0) {
                this.color1 = "#008CFF"
            } else if (this.current2 == 1) {
                this.color1 = "#0BBCB2"
            } else if (this.current2 == 2) {
                this.color1 = "#FFBB00"
            } else if (this.current2 == 3) {
                this.color1 = "#FF0000"
            }
            this.val2 = val.value;
            this.eIndex = val.id
            this.index = index
        },
        close() {
            this.eShow1 = 0
            this.eShow2 = 0
            this.engDig = false
        },
        ftSelect() {
            this.eShow1 = 1;
        },
        etSelect() {
            this.eShow2 = 1;
        },
        // 下面是关于选择最迟解决时间的几个方法
        cTSelect() {
            this.showTime = true;
        },
        //取消选择时间
        cacelSelTime() {
            this.showTime = false;
        },
        //选择时间
        sleDate(value) {
            // console.log(value)
            this.showTime = false;
            this.TType = this.getTime(JSON.stringify(value));
            this.lastFinishTime = value;
            // console.log(this.lastFinishTime)
            // this.$emit('devopsEnginnerImmediatelySupport', value,this.recordId);
        },
        getTime(time) {
            var T_pos = time.indexOf("T");
            var Z_pos = time.indexOf("Z");
            var year_month_day = time.substr(1, T_pos - 1);
            var minute_second = time.substr(T_pos + 3, Z_pos - T_pos - 7);
            var hour = parseInt(time.substr(T_pos + 1, Z_pos - T_pos - 10)) + 8;
            var new_datetime = year_month_day + " " + hour + minute_second; // 2017-03-31 08:02:06
            return new_datetime;
        },
        getlevelData(companyId) {
            let data = { dictType: 1, companyId: companyId }
            this.$api.get('/appConfigDictData/selectConfig', { params: data }).then(res => {
                if (res.data.code == "0000") {
                    this.failItem = res.data.data
                } else if (res.data.code == "9999") {
                    this.$toast(res.data.message)
                }
            }
            )

        },
        getDescribeData(companyId) {
            let data = { dictType: 2, companyId: companyId }
            this.$api.get('/appConfigDictData/selectConfig', { params: data }).then(res => {
                if (res.data.code == "0000") {
                    this.estItem = res.data.data
                } else if (res.data.code == "9999") {
                    this.$toast(res.data.message)
                }
            }
            )

        },
        submitBill() {
            // let tmsg = this.message ? this.message : this.tmsg
            // if (this.fType && (this.fType != '请选择') && tmsg) {
            if (this.message == "") {
                this.hpType = true;
                this.hpText = "请输入说明";
            } else {
                this.hpType = false;
                this.hpText = "说明"
            }
            let tmsg = this.tmsg + '：' + this.message;
            if ( this.eType && this.fType && this.lastFinishTime && this.eType != "请选择" && this.fType != "请选择" && this.tmsg != "" && !this.hpType ) {
                this.disabled = true
                let data = {
                    assetsId: this.$route.query.id,//资产设备id
                    assetsType: this.$route.query.dictId,//资产类型
                    companyId: this.$route.query.responseType == 1 ? this.itemList.companyId : this.item.companyId,//资产所属用户单位id
                    createBy: this.$route.query.responseType == 1 ? this.itemList.dutyBy : this.item.dutyBy,//创建者
                    dutyId: this.$route.query.responseType == 1 ? this.itemList.dutyBy : this.item.dutyBy,//	
                    exemplar: 2,//形式：1.主动式运维、2.被动式运维
                    lastFinishTime: this.lastFinishTime,//最迟解决时间
                    maintenanceId: JSON.parse(this.$route.query.dutyBy),//报修人id
                    maintenanceName: this.$route.query.responseType == 1 ? this.itemList.dutyPerson : this.item.dutyPerson,//报修人姓名
                    maintenanceTel: this.$route.query.responseType == 1 ? this.itemList.dutyPhone : this.item.dutyPhone,//报修人电话
                    maintenanceType: 0,//报修人类型0用户1工程师
                    responseType: 4,//响应类型1硬件2软件3其他
                    source: 2,//来源：1.日常巡检、2.日常工单
                    supportDescribe: tmsg,//故障描述
                    supportLevel: JSON.parse(this.eIndex),//故障级别(0低1中2高3紧急)
                    supportType: JSON.parse(this.fIndex),//故障类型(0日常1通信2供电3不可抗拒4设备供应)

                };
                this.$api.post('/app/support/supportRecordReport', data).then(res => {
                    this.disabled = false
                    if (res.data.code == "0000") {
                        this.engDig = true;
                    } else if (res.data.code == "9999") {
                        this.$toast(res.data.message)
                    }
                }
                )
            } else {
                if (!this.fType) {
                    this.fType = "请选择";
                }
                if (!this.eType) {
                    this.eType = "请选择";
                }
                if (!this.TType) {
                    this.TType = "请选择";
                }
                if (this.tmsg == "") {
                    this.hType = true;
                } else {
                    this.hType = false;
                }
                if (!this.message) {
                    this.hpType = true;
                }
            }
        },
        closeDig() {
            if (this.$route.query.responseType == 1) {
                this.itemList.tOpen = 1
                this.yjShow = true
            } else if (this.$route.query.responseType == 2) {
                this.item.tOpen = 1
                this.yjShow = false
            }


            this.diag = false

            this.index = -1
            this.diag = false
            this.message = ''
            this.tmsg = ''
            this.current = null
            this.current1 = null
            this.current2 = null
            this.eShow1 = false
            this.eShow2 = false
            this.bSty = true
            this.fType = ''
            this.fIndex = ''
            this.val1 = ''
            this.eIndex = ""
            this.val2 = ''
            this.hType = false
            this.fhShow = true
            this.engDig = false
            this.disabled = false
            this.engDig = false;
            // this.$router.push('/index')
        }


    }
}
</script>
<style scoped>
button {
    border: none;
    padding: 0;
    margin: 0;
}
.mainSty3 {
    width: 345px;
    height: 384px;
    padding: 14px 21px 0 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.mainSty4 {
    width: 345px;
    height: 1068px;
    padding: 14px 21px 0 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.mainSty2 {
    width: 345px;
    height: 422px;
    padding: 14px 21px 0 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.mainSty1 {
    width: 345px;
    height: 650px;
    padding: 14px 21px 0 21px;
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
    margin-bottom: 20px;
    box-sizing: border-box;
}
.wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2002;
    overflow: auto;
    overflow-x: hidden;
    background: #e9eef2;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 100%;
}

.mainSty {
    width: 345px;
    height: 100%;
    /* padding:14px 21px; */
    margin: 0 auto;
    margin-top: 20px;
    border-radius: 4px;
    /*        box-shadow: 0px 3px 6px 0px rgba(16,82,139,0.16);
        background:#fff; */
}

/* .mtSty:nth-child(3n){ 
		margin-bottom:10px;
	}  */
.mtSty {
    margin-bottom: 10px;
    margin-right: 10px;
    display: inline-block;
}
.alSty {
    background: #fff;
    padding: 0 21px;
    border-radius: 4px 4px 0 0;
}
.alSty1 {
    background: #fff;
    padding: 5px 21px;
    border-radius: 0 0 4px 4px;
}
.ofSty {
    width: 100%;
    height: 350px;
    overflow: auto;
}
.rectSty {
    margin: 0 auto;
    width: 10px;
    height: 100%;
    border: 1px solid #0080ff;
    border-radius: 15px;
}
.hBorder {
    border: 1px solid red !important;
}
.fHeight {
    /* height:270px; */
}
.e_rect {
    /* width: 68px; */
    height: 25px;
    line-height: 25px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid #707070;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    margin: 0 auto;
    display: inline-block;
    padding: 0 5px;
}
.active {
    color: #0080ff !important;
    border: 1px solid #0080ff !important;
}
.blk1 {
    position: relative;
    width: 100%;
    height: 148px;
}
.blk1 {
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;
}
.blka {
    vertical-align: bottom;
    box-sizing: border-box;
    width: 345px;
    height: 38px;
    display: flex;
    align-items: flex-end;
    margin-bottom: 0;
    padding: 5px;
    background: #fff;
}
.txta {
    width: 200px;
    height: 28px;
    overflow: hidden;
    margin-left: 20px;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 2;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
}
.txtb {
    width: 200px;
    height: 28px;
    overflow: hidden;
    margin-left: 20px;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 1;
    font-size: 9px;
    font-weight: 400;
    color: #333333;
}
.blkb {
    position: relative;
    margin: 0 auto;
    padding: 13px 13px 8px 13px;
    background: #fff;
    border-bottom: 1px solid #bfbfbf;
}
.txtc {
    position: absolute;
    top: 10px;
    left: 0;
    width: 4px;
    height: 13px;
    background: #1aaeff;
}
.txtd {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
}
.blkc {
    display: flex;
    height: 22px;
    margin-top: 8px;
}
.txte {
    flex: 1;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
.blkf {
    flex: 0 0 22px;
}
.imga {
    float: left;
    width: 22px;
    height: 22px;
}
.blkg {
    position: relative;
    margin: 0 auto;
    padding: 8px 13px;
    background: #fff;
    border-bottom: 1px solid #bfbfbf;
}
.blkg1 {
    position: relative;
    margin: 0 auto;
    padding: 13px 13px 8px 13px;
    background: #fff;
    border-bottom: 1px solid #bfbfbf;
}
.blkh {
    display: flex;
    height: 26px;
    margin-top: 8px;
}
.blkh1 {
    display: flex;
    margin-top: 8px;
}
.txth {
    flex: 1;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
.blkn {
    display: flex;
    flex-direction: row;
    margin-top: 45px;
}
.btnn {
    width: 281px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    margin: 0 auto;
}
.blkps {
    position: absolute;
    top: 48px;
    right: 52px;
    width: 90px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.blkop {
    /* margin: 10px 10px 5px 10px; */
}
.inpup {
    border: 1px solid #0080ff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
}
.mtblk {
    width: 100%;
    height: 100%;
}
.dialogs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 490px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.dialogs2 {
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0 15px;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 400px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.dialogs1 {
    height: 179px;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.digtxt1 {
    width: 200px;
    height: 30px;
    font-size: 22px;
    margin: 26px auto;
    font-weight: 800;
    text-align: center;
    color: #003cff;
    line-height: 30px;
}
.digtxt2 {
    width: 200px;
    height: 56px;
    margin: 0px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 211px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    margin-top: 20px;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
}
.eng2txt {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: #999999;
    line-height: 12px;
}
.nbtn {
    width: 211px;
    height: 42px;
    background: #eeeeee;
    border-radius: 21px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    color: #666666;
    line-height: 42px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
}
.nbtn1 {
    width: 149px;
}
.active1 {
    background: #ffffff;
    border: 2px solid #008cff;
    border-radius: 21px;
    color: #008cff;
}
.active2 {
    width: 149px;
    height: 42px;
    background: #ffffff;
    border: 2px solid #0bbcb2;
    border-radius: 21px;
}
.imghj {
    width: 50px;
    height: 215px;
}
.imgblk {
    display: flex;
    position: absolute;
    top: 8px;
    right: 12px;
    width: 12px;
    height: 12px;
}
.imgtlk {
    flex: 1;
    width: 100%;
    height: 100%;
}
.height0 {
    width: 100%;
    height: 0%;
    background: green;
    border-radius: 15px;
}
.height1 {
    width: 100%;
    height: 25%;
    background: #0080ff;
    border-radius: 15px;
}
.height2 {
    width: 100%;
    height: 50%;
    background: #0bbcb2;
    border-radius: 15px;
}
.height3 {
    width: 100%;
    height: 75%;
    background: #ffbb00;
    border-radius: 15px;
}
.height4 {
    width: 100%;
    height: 100%;
    background: #ff0000;
    border-radius: 15px;
}
.sRect0 {
    width: 30px;
    height: 30px;
    background: #0080ff;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect1 {
    width: 30px;
    height: 30px;
    background: #0080ff;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect2 {
    width: 30px;
    height: 30px;
    background: #0bbcb2;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect3 {
    width: 30px;
    height: 30px;
    background: #ffbb00;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.sRect4 {
    width: 30px;
    height: 30px;
    background: #ff0000;
    border-radius: 30px;
    margin-top: -15px;
    margin-left: -10px;
    position: relative;
}
.tRect {
    width: 15px;
    height: 15px;
    background: #fff;
    border-radius: 10px;
    margin: 0;
    position: absolute;
    top: 7.5px;
    left: 7.5px;
}
.txt1 {
    width: 290px;
    height: 28px;
    line-height: 28px;
    overflow: hidden;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 1;
    font-size: 20px;
    font-weight: 400;
    color: #333333;
}
.txt2 {
    width: 290px;
    height: 28px;
    line-height: 28px;
    overflow: hidden;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    flex: 1;
    font-size: 9px;
    font-weight: 400;
    color: #333333;
}
.blk2 {
    display: flex;
    flex-direction: row;
    height: 48px;
}
.btn1 {
    width: 136px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #0bbcb2 11%, #0bbc98 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.btn16 {
    width: 59px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    background: #8dc6ff;
    border-radius: 12px;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
}
.btn2 {
    width: 146px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: linear-gradient(116deg, #36b3fe 11%, #0080ff 91%);
    border-radius: 22px;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.blkn3 {
    width: 290px;
    height: 28px;
    overflow: hidden;
    vertical-align: bottom;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    display: flex;
    align-items: flex-end;
    margin-bottom: 0px;
}
.blkt {
    height: 38px;
    line-height: 18px;
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 10px 0px;
    background: #fff;
    border-bottom: 1px solid #f2f2f2;
}
.txt11 {
    overflow: hidden;
    　　text-overflow: ellipsis;
    　　white-space: wrap;
    flex: 0 0 160px;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    color: #666;
}
.txt12 {
    word-break: break-all;
    flex: 1;
    text-align: right;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
}
</style>
